module.exports = __webpack_public_path__ + "a2d907f850d8b77c56e4eabfa6984ae4.pdf";